<template>
  <div class="form-group col-lg-4">
    <label for="power" class="font-weight-bold text-dark text-2">{{ trans('Power') }}</label>
    <div class="row">
      <div class="col-6">
        <input id="power"
               type="text"
               placeholder="44"
               :value="value"
               @input="unitUpdateHandler"
               @change="unitUpdateHandler"
               :disabled="disabled"
               class="form-control"
        >
      </div>
      <div class="col-6 pl-0">
        <v-select :value="unit"
                  @input="val => this.$emit('unitChange', val)"
                  placeholder="HP"
                  :disabled="disabled"
                  :clearable="false"
                  :reduce="option => option.value"
                  :options="[
                    { value: 'hp', label: 'HP' },
                    { value: 'kw', label: 'KW' },
                  ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PowerInput",

    props: {
      value: {
        type: [Number, String],
        default: '',
      },
      unit: {
        type: String,
        default: 'hp',
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        id: null,
        unitAuto: null,
      }
    },

    mounted() {
      this.id = this.$options.name + this._uid;
    },

    computed: {
      valueHp() {
        const unit = this.unit || 'hp';
        return unit === 'hp' ?
          Math.round(parseFloat(this.value)) :
          Math.round(parseFloat(this.value) / 0.73549875);
      },
    },

    methods: {
      unitUpdateHandler(event) {
        const val = event.target.value;

        const re = /(?<val>[\d,.]+?)(?<unit>[\sa-z]+)/gi;
        const reLeadingLetters = /^\D+/g;
        const result = re.exec(String(val).replace(reLeadingLetters, ''));
        let value;

        if (result) {
          const inputUnit = result.groups.unit.trim().toLowerCase();
          const inputValue = result.groups.val.trim();

          if (inputUnit === 'kw') {
            this.unit = 'kw';
            this.$emit('unitChange', 'kw');
          } else if (inputUnit) {
            this.unit = 'hp';
            this.$emit('unitChange', 'hp');
          }

          value = inputValue.replace(',', '.');
        } else {
          value = String(val).replace(',', '.');
        }

        this.$emit('input', value);
      },
    },

    watch: {
      valueHp(val) {
        this.$emit('hpValueChange', val);
      },
    },
  }
</script>
